import { AccountCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import React from 'react';
import { CertificationTypeToRenderDetails } from '../CertificationsUtils';
import s from './CertificationDisplay.module.scss';

const LabeledCertification = ({
  cert,
  isMobile,
}: {
  cert: AccountCertification;
  isMobile?: boolean;
}) => {
  const { t } = useTranslation();
  const renderDetails =
    CertificationTypeToRenderDetails[cert.certificationType!];

  if (!renderDetails) {
    return null; // Don't render unsupported certification types
  }

  const CertificationImage = renderDetails.Component as React.FC<{
    width: number;
    height: number;
  }>;
  const labelKey = renderDetails.label;
  const imgDimension = isMobile ? 72 : 48;
  const certYear = new Date(cert.createdDate!).getFullYear();

  return (
    <Box
      key={cert.certificationType}
      direction={isMobile ? 'horizontal' : 'vertical'}
      align="center"
      width="max-content"
      gap={isMobile ? '18px' : '6px'}
    >
      <CertificationImage width={imgDimension} height={imgDimension} />
      <Box
        className={`${s.LabeledCertificationTexts} ${isMobile ? s.mobile : ''}`}
        direction="vertical"
      >
        <Text size={isMobile ? 'medium' : 'tiny'} weight="thin">
          {t(labelKey)} ({certYear})
        </Text>
      </Box>
    </Box>
  );
};

export default LabeledCertification;
